import React from 'react';

import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

interface FullscreenButtonProps {
  isFullscreen: boolean;
  onToggle: () => void;
}

const FullscreenButton: React.FC<FullscreenButtonProps> = ({
  isFullscreen,
  onToggle,
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={
        isFullscreen
          ? t('scenes.dynamic_viewer.tooltips.exit_fullscreen')
          : t('scenes.dynamic_viewer.tooltips.enter_fullscreen')
      }
    >
      <Button
        type="primary"
        icon={
          isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />
        }
        onClick={onToggle}
        style={{
          position: 'absolute',
          bottom: '16px',
          right: '16px',
          zIndex: 10,
          opacity: 0.7,
          transition: 'opacity 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = '1';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = '0.7';
        }}
        className="fullscreen-button"
      />
    </Tooltip>
  );
};

export default FullscreenButton;
